import { Provider } from '@angular/core';
import { IntegrationTableJobService } from '@y42/integration';
import { SqlModelingTableJobService } from '@y42/sql-model';
import { UiModelingTableJobService } from '@y42/ui-model';
import { ExportTriggerJobService } from '@y42/data-export';
import { FeatureChildJobServiceInjectionToken } from './feature-child-job-service.injection-token';

export function provideFeatureChildJobServices(): Provider[] {
  return [
    {
      provide: FeatureChildJobServiceInjectionToken,
      multi: true,
      useExisting: IntegrationTableJobService,
    },
    {
      provide: FeatureChildJobServiceInjectionToken,
      multi: true,
      useExisting: UiModelingTableJobService,
    },
    {
      provide: FeatureChildJobServiceInjectionToken,
      multi: true,
      useExisting: SqlModelingTableJobService,
    },
    {
      provide: FeatureChildJobServiceInjectionToken,
      multi: true,
      useExisting: ExportTriggerJobService,
    },
  ];
}
